import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { PartMenuComponent } from '../../menus/index';

import { routedComponents, PluginRoutingModule } from './plugin.routing';
import { PluginMenuModule } from './plugin-menu.module';

import { ApiService, DataService, InspectionPluginService } from '../../shared/services/index';
import { SharedModule } from '../../shared.module';

import { PluginComponent } from '../plugin.component';
import { PluginDirective } from '../plugin.directive';

import { FileManagerModule } from '../../file-manager/file-manager.module';
import { AngularEditorModule } from '@kolkov/angular-editor';

import {
  ActionParticipantsPluginComponent,
  ActionParticipantsPluginService,
  ActionsPipe,
  ActionsCompletedPluginComponent,
  ActionsCompletedPluginService,
  AddObservationComponent,
  AppCurrencyPipe,
  AssociateEquipmentPluginComponent,
  AssociateEquipmentService,
  AssociateEqupmentFactoryService,
  AttachementsPluginComponent,
  AttachementsPluginFactoryService,
  AttachementsPluginService,
  BarreDePincesLockingCheckPluginComponent,
  BarreDePincesLockingCheckPluginService,
  BaseInstallationEditPageComponent,
  BaseInstallationPluginComponent,
  BoxesPluginComponent,
  BoxesPluginService,
  CheckedStatusPipe,
  CommentPluginComponent,
  CommentPluginFactoryService,
  CommentPluginService,
  CommentToPipe,
  CommentTypePipe,
  FileToTypePipe,
  FileAndSuggestionToTypePipe,
  ContactPluginComponent,
  ContactPluginFactoryService,
  ContactPluginService,
  CounterPluginComponent,
  CounterPluginService,
  CounterPressureCylinderPluginComponent,
  CounterPressureCylinderPluginService,
  CountryPipe,
  CoursePipe,
  CreateFolderComponent,
  CustomerCommentFromPipe,
  CustomerRemarkFactoryService,
  CustomerRemarkPluginComponent,
  CustomerRemarkPluginService,
  CustomerRemarkTypePipe,
  CustomerSelectorFactoryPluginService,
  CustomerSelectorPluginComponent,
  CustomerSelectorPluginService,
  CyclesPluginComponent,
  CyclesPluginService,
  CylindricalParallelismPluginComponent,
  CylindricalParallelismPluginService,
  DatePluginComponent,
  DatePluginService,
  DiscussionCommentTypePipe,
  DiscussionPluginComponent,
  DiscussionPluginService,
  DocumentTypePipe,
  DynamicDirective,
  EditModalFooterComponent,
  EditModalHeaderComponent,
  EditObservationComponent,
  PluginPreviewValidationMessagesComponent,
  ExecutiveSummaryPluginComponent,
  ExecutiveSummaryPluginService,
  FileManagerPluginComponent,
  FileManagerPluginService,
  FilesAndSuggestionsPluginComponent,
  FilesAndSuggestionsPluginService,
  FilesPluginComponent,
  FilesPluginFactoryService,
  FilesPluginService,
  FunctionPipe,
  IconPipe,
  IconTypePipe,
  ImportanceLevelPipe,
  IncotermsStatusPipe,
  InspectionInfoFactoryService,
  InspectionInfoPluginComponent,
  InspectionInfoPluginService,
  InspectionTypePipe,
  InstallationAniloxPluginComponent,
  InstallationAniloxPluginService,
  InstallationBobstAttendeesPluginComponent,
  InstallationBobstAttendeesPluginService,
  InstallationBobstContactPluginComponent,
  InstallationBobstContactPluginFactoryService,
  InstallationBobstContactPluginService,
  InstallationCheckedPluginComponent,
  InstallationCheckedPluginFactoryService,
  InstallationCheckedPluginService,
  InstallationCommentsPluginComponent,
  InstallationCommentsPluginService,
  InstallationCustomerAttendeesPluginComponent,
  InstallationCustomerAttendeesPluginService,
  InstallationCustomerCommentsPluginComponent,
  InstallationCustomerCommentsPluginService,
  InstallationCustomerContactPluginComponent,
  InstallationCustomerContactPluginFactoryService,
  InstallationCustomerContactPluginService,
  InstallationCustomerInfoFactoryPluginService,
  InstallationCustomerInfoPluginComponent,
  InstallationCustomerInfoPluginService,
  InstallationDatePluginComponent,
  InstallationDatePluginService,
  InstallationDimensionPluginComponent,
  ReportAdvisePluginComponent,
  ReportAdvisePluginService,
  AssistancePluginComponent,
  AssistancePluginService,
  AssistanceActionPipe,
  InstallationDimensionPluginService,
  InstallationDistancePipe,
  InstallationDistancePluginComponent,
  InstallationDistancePluginService,
  InstallationDurationPluginComponent,
  InstallationDurationPluginService,
  InstallationEquipmentInfoPluginComponent,
  InstallationEquipmentInfoPluginFactoryService,
  InstallationEquipmentInfoPluginService,
  InstallationExecutiveSummaryPluginComponent,
  InstallationExecutiveSummaryPluginService,
  InstallationFreeTextPluginComponent,
  InstallationFreeTextPluginService,
  InstallationGroundLevelPluginComponent,
  InstallationGroundLevelPluginService,
  InstallationIncotermsPluginComponent,
  InstallationIncotermsPluginService,
  InstallationInspectionInfoFactoryService,
  InstallationInspectionInfoPluginComponent,
  InstallationinspectionInfoPluginService,
  InstallationJobProducedEditPageComponent,
  InstallationJobProducedPluginComponent,
  InstallationJobProducedPluginService,
  InstallationLubricantPluginComponent,
  InstallationLubricantPluginService,
  InstallationPartyBccBsaPluginComponent,
  InstallationPartyBccBsaPluginService,
  InstallationPreparationNeededPluginComponent,
  InstallationPreparationNeededPluginService,
  InstallationPreparationPipe,
  InstallationReceivedPluginComponent,
  InstallationReceivedPluginFactoryService,
  InstallationReceivedPluginService,
  InstallationRoadSurfacePluginComponent,
  InstallationRoadSurfacePluginService,
  InstallationSignaturePluginComponent,
  InstallationSignaturePluginService,
  InstallationStaffPluginComponent,
  InstallationStaffPluginService,
  InstallationStatusPluginComponent,
  InstallationStatusPluginService,
  InstallationTrainingProvidedEditPageComponent,
  InstallationTrainingProvidedPluginComponent,
  InstallationTrainingProvidedPluginService,
  InstallationVoltagePluginComponent,
  InstallationVoltagePluginFactoryService,
  InstallationVoltagePluginService,
  InstallationWeightPluginComponent,
  InstallationWeightPluginService,
  InstallationYesNoPluginComponent,
  InstallationYesNoPluginService,
  JobAnalysisPluginComponent,
  JobAnalysisPluginService,
  JobLabelPipe,
  LanguagesPipe,
  LevelTypePipe,
  MachineSelectorFactoryService,
  MachineSelectorPluginComponent,
  MachineSelectorPluginService,
  MarketingPluginComponent,
  MarketingPluginService,
  MeasuringUnitsPipe,
  MomentPipe,
  NumberThousandPipe,
  ObservationsAndRecommandationsFactoryService,
  ObservationsAndRecommandationsPluginComponent,
  ObservationsAndRecommandationsPluginService,
  OptimisationMachineSelectorFactoryService,
  OptimisationMachineSelectorPluginComponent,
  OptmizationMachineSelectorPluginService,
  OwnerTypePipe,
  ParticipantsPluginComponent,
  ParticipantsPluginService,
  PartsFilterPipe,
  PartsPluginComponent,
  PartsPluginFactoryService,
  PartsPluginService,
  PartsViewModalComponent,
  PeripheralInfoFactoryPluginService,
  PeripheralInfoPluginComponent,
  PeripheralInfoPluginService,
  PersonNamePipe,
  PrioritiesPipe,
  ReceivedStatusPipe,
  RecommendedPartsPluginComponent,
  RecommendedPartsPluginService,
  RepairDaysPluginComponent,
  RepairDaysPluginService,
  ReparatorPipe,
  ResponseBooleanPluginComponent,
  ResponseDatePluginComponent,
  ResponseNumberPluginComponent,
  ResponsePluginService,
  ResponsiblesPipe,
  SoftwareInfoPluginComponent,
  SoftwareInfoPluginService,
  SpoLockingPluginComponent,
  SpoLockingPluginService,
  StaffTypesPipe,
  StatesPipe,
  StatesPluginComponent,
  StatesPluginFactoryService,
  StatesPluginService,
  StatusTypePipe,
  SubTypePipe,
  SupplierPipe,
  SurfaceTypePipe,
  TimeCounterPluginComponent,
  TimeCounterPluginFactoryService,
  TimeCounterPluginService,
  TimeSheetPluginComponent,
  TimeSheetPluginService,
  TimeToRepairPluginComponent,
  TimeToRepairPluginService,
  TimeUnitsPipe,
  TotalTimeToRepairPluginComponent,
  TotalTimeToRepairPluginService,
  TrainerPipe,
  TrainingProposalsPluginComponent,
  TrainingProposalsPluginService,
  WeightUnitsPipe,
  YesNoStatusPipe,
  SignatureTypePipe,
  InstallationFormFilePluginComponent,
  InstallationFormFilePluginService,
  AddInstallationObservationComponent,
  EditInstallationObservationComponent,
  InstallationObservationPluginPageComponent,
  InstallationObservationPluginComponent,
  ObservationPrioritiesPipe,
  ObservationResponsiblesPipe,
  InstallationObservationPluginService,
  InstallationObservationFactoryService,
  InterventionTasksPluginService,
  InterventionTasksPluginComponent,
  ObsolescencesPluginComponent,
  UpgradesPluginComponent,
  StatePriorityPipe,
  SpoTrainPluginComponent,
  SpoTrainPluginService,
  MachineSafetyPluginComponent,
  MachineSafetyPluginService,
  MachineSafetyYesNoPipe,
  ScorePluginComponent,
  ScorePluginService,
  ActionsPluginComponent,
  ActionsPluginService,
  EffectsPluginComponent,
  EffectsEditPageComponent,
  EffectsPluginService,
  InherentRiskPluginComponent,
  InherentRiskEditPageComponent,
  InherentRiskPluginService,
  InherentRiskImpactPipe
} from '..';
// WARNING : all plugins must be in the barrel above "import from '..'"", otherwise the prod build might not find the plugin
import { SmartreportPartsviewLibraryModule } from '../../partsview/smartreport-partsview-library.module';
import { UpgradeDetailsModalComponent } from '../upgrades/upgrade-details/upgrade-details.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    PluginRoutingModule,
    PluginMenuModule,
    FileManagerModule,
    AngularEditorModule,
    SmartreportPartsviewLibraryModule
  ],
  declarations: [
    ...routedComponents,
    ActionsCompletedPluginComponent,
    CommentPluginComponent,
    FilesPluginComponent,
    CustomerSelectorPluginComponent,
    BarreDePincesLockingCheckPluginComponent,
    CylindricalParallelismPluginComponent,
    CounterPressureCylinderPluginComponent,
    StatesPluginComponent,
    TimeToRepairPluginComponent,
    TotalTimeToRepairPluginComponent,
    PartsPluginComponent,
    PartsViewModalComponent,
    CounterPluginComponent,
    TimeCounterPluginComponent,
    PartMenuComponent,
    TimeSheetPluginComponent,
    SoftwareInfoPluginComponent,
    CyclesPluginComponent,
    BoxesPluginComponent,
    InspectionInfoPluginComponent,
    CustomerRemarkPluginComponent,
    ContactPluginComponent,
    MachineSelectorPluginComponent,
    DiscussionPluginComponent,
    ObservationsAndRecommandationsPluginComponent,
    EditObservationComponent,
    AddObservationComponent,
    FilesAndSuggestionsPluginComponent,
    ReportAdvisePluginComponent,
    AssistancePluginComponent,
    CustomerRemarkTypePipe,
    CommentTypePipe,
    FileToTypePipe,
    FileAndSuggestionToTypePipe,
    ImportanceLevelPipe,
    IconPipe,
    IconTypePipe,
    AssistanceActionPipe,
    TrainingProposalsPluginComponent,
    TrainerPipe,
    CoursePipe,
    MomentPipe,
    ReparatorPipe,
    LanguagesPipe,
    InspectionTypePipe,
    ActionsPipe,
    StatePriorityPipe,
    StatesPipe,
    DocumentTypePipe,
    ReceivedStatusPipe,
    ExecutiveSummaryPluginComponent,
    PersonNamePipe,
    DiscussionCommentTypePipe,
    PartsFilterPipe,
    CountryPipe,
    OptimisationMachineSelectorPluginComponent,
    AttachementsPluginComponent,
    JobAnalysisPluginComponent,
    PeripheralInfoPluginComponent,
    RecommendedPartsPluginComponent,
    AppCurrencyPipe,
    PrioritiesPipe,
    ResponsiblesPipe,
    AssociateEquipmentPluginComponent,
    NumberThousandPipe,
    PluginComponent,
    PluginDirective,
    DynamicDirective,
    RepairDaysPluginComponent,
    DatePluginComponent,
    FileManagerPluginComponent,
    ParticipantsPluginComponent,
    ActionParticipantsPluginComponent,
    CreateFolderComponent,
    ResponseDatePluginComponent,
    ResponseNumberPluginComponent,
    ResponseBooleanPluginComponent,
    SpoLockingPluginComponent,
    MarketingPluginComponent,
    InterventionTasksPluginComponent,
    UpgradesPluginComponent,
    ObsolescencesPluginComponent,
    UpgradeDetailsModalComponent,
    SpoTrainPluginComponent,
    MachineSafetyPluginComponent,
    ScorePluginComponent,
    ActionsPluginComponent,
    EffectsPluginComponent,
    InherentRiskPluginComponent,

    //installation components
    InstallationAniloxPluginComponent,
    InstallationPartyBccBsaPluginComponent,
    InstallationBobstAttendeesPluginComponent,
    InstallationBobstContactPluginComponent,
    InstallationCheckedPluginComponent,
    InstallationCustomerAttendeesPluginComponent,
    InstallationCustomerCommentsPluginComponent,
    InstallationCustomerContactPluginComponent,
    InstallationCustomerInfoPluginComponent,
    InstallationDimensionPluginComponent,
    InstallationDistancePluginComponent,
    InstallationDurationPluginComponent,
    InstallationEquipmentInfoPluginComponent,
    InstallationFreeTextPluginComponent,
    InstallationGroundLevelPluginComponent,
    InstallationIncotermsPluginComponent,
    InstallationCommentsPluginComponent,
    InstallationDatePluginComponent,
    InstallationInspectionInfoPluginComponent,
    InstallationLubricantPluginComponent,
    InstallationPreparationNeededPluginComponent,
    InstallationReceivedPluginComponent,
    InstallationRoadSurfacePluginComponent,
    InstallationSignaturePluginComponent,
    InstallationStaffPluginComponent,
    InstallationStatusPluginComponent,
    InstallationVoltagePluginComponent,
    InstallationWeightPluginComponent,
    InstallationYesNoPluginComponent,
    BaseInstallationPluginComponent,
    BaseInstallationEditPageComponent,
    EditModalFooterComponent,
    EditModalHeaderComponent,
    PluginPreviewValidationMessagesComponent,
    InstallationJobProducedPluginComponent,
    InstallationJobProducedEditPageComponent,
    InstallationTrainingProvidedPluginComponent,
    InstallationTrainingProvidedEditPageComponent,
    InstallationExecutiveSummaryPluginComponent,
    InstallationFormFilePluginComponent,
    AddInstallationObservationComponent,
    EditInstallationObservationComponent,
    InstallationObservationPluginPageComponent,
    InstallationObservationPluginComponent,

    //installation pipes
    WeightUnitsPipe,
    CheckedStatusPipe,
    IncotermsStatusPipe,
    MeasuringUnitsPipe,
    SurfaceTypePipe,
    LevelTypePipe,
    SupplierPipe,
    StaffTypesPipe,
    TimeUnitsPipe,
    StatusTypePipe,
    InstallationPreparationPipe,
    InstallationDistancePipe,
    CustomerCommentFromPipe,
    CommentToPipe,
    OwnerTypePipe,
    FunctionPipe,
    SubTypePipe,
    JobLabelPipe,
    YesNoStatusPipe,
    SignatureTypePipe,
    ObservationPrioritiesPipe,
    ObservationResponsiblesPipe,
    MachineSafetyYesNoPipe,
    InherentRiskImpactPipe
  ],
  providers: [
    ApiService,
    DataService,
    InspectionPluginService,
    ActionsCompletedPluginService,
    CommentPluginService,
    FilesPluginService,
    MachineSelectorPluginService,
    CustomerSelectorPluginService,
    BarreDePincesLockingCheckPluginService,
    CylindricalParallelismPluginService,
    CounterPressureCylinderPluginService,
    StatesPluginService,
    TimeToRepairPluginService,
    TotalTimeToRepairPluginService,
    PartsPluginService,
    CounterPluginService,
    TimeCounterPluginService,
    SoftwareInfoPluginService,
    CyclesPluginService,
    BoxesPluginService,
    InspectionInfoPluginService,
    CustomerRemarkPluginService,
    ContactPluginService,
    ObservationsAndRecommandationsPluginService,
    FilesAndSuggestionsPluginService,
    TrainingProposalsPluginService,
    ExecutiveSummaryPluginService,
    TrainerPipe,
    TimeSheetPluginService,
    DiscussionPluginService,
    AttachementsPluginService,
    JobAnalysisPluginService,
    OptmizationMachineSelectorPluginService,
    PeripheralInfoPluginService,
    RecommendedPartsPluginService,
    AssociateEquipmentService,
    FilesPluginFactoryService,
    TimeCounterPluginFactoryService,
    StatesPluginFactoryService,
    PartsPluginFactoryService,
    AssociateEqupmentFactoryService,
    CustomerSelectorFactoryPluginService,
    ContactPluginFactoryService,
    InspectionInfoFactoryService,
    MachineSelectorFactoryService,
    AttachementsPluginFactoryService,
    ObservationsAndRecommandationsFactoryService,
    OptimisationMachineSelectorFactoryService,
    CustomerRemarkFactoryService,
    PeripheralInfoFactoryPluginService,
    CommentPluginFactoryService,
    RepairDaysPluginService,
    DatePluginService,
    FileManagerPluginService,
    ParticipantsPluginService,
    ActionParticipantsPluginService,
    ResponsePluginService,
    SpoLockingPluginService,
    MarketingPluginService,
    InterventionTasksPluginService,
    SpoTrainPluginService,
    MachineSafetyPluginService,
    ScorePluginService,
    ActionsPluginService,
    EffectsPluginService,
    InherentRiskPluginService,
    ReportAdvisePluginService,
    AssistancePluginService,

    //installation services
    InstallationAniloxPluginService,
    InstallationPartyBccBsaPluginService,
    InstallationBobstAttendeesPluginService,
    InstallationBobstContactPluginService,
    InstallationCheckedPluginService,
    InstallationReceivedPluginFactoryService,
    InstallationCustomerAttendeesPluginService,
    InstallationCustomerCommentsPluginService,
    InstallationCustomerContactPluginService,
    InstallationCustomerInfoPluginService,
    InstallationDimensionPluginService,
    InstallationDistancePluginService,
    InstallationDurationPluginService,
    InstallationEquipmentInfoPluginService,
    InstallationFreeTextPluginService,
    InstallationGroundLevelPluginService,
    InstallationIncotermsPluginService,
    InstallationCommentsPluginService,
    InstallationDatePluginService,
    InstallationinspectionInfoPluginService,
    InstallationLubricantPluginService,
    InstallationPreparationNeededPluginService,
    InstallationReceivedPluginService,
    InstallationRoadSurfacePluginService,
    InstallationSignaturePluginService,
    InstallationStaffPluginService,
    InstallationStatusPluginService,
    InstallationVoltagePluginService,
    InstallationWeightPluginService,
    InstallationYesNoPluginService,
    InstallationJobProducedPluginService,
    InstallationTrainingProvidedPluginService,
    InstallationExecutiveSummaryPluginService,
    FunctionPipe,
    InstallationFormFilePluginService,
    InstallationObservationPluginService,

    //installation factories
    InstallationCheckedPluginFactoryService,
    InstallationCustomerContactPluginFactoryService,
    InstallationVoltagePluginFactoryService,
    InstallationCustomerInfoFactoryPluginService,
    InstallationInspectionInfoFactoryService,
    InstallationEquipmentInfoPluginFactoryService,
    InstallationBobstContactPluginFactoryService,
    InstallationObservationFactoryService,
    InstallationObservationFactoryService
  ],
  exports: [
    CommentPluginComponent,
    PluginMenuModule,
    EditObservationComponent,
    AddObservationComponent,
    CustomerRemarkTypePipe,
    CommentTypePipe,
    FileToTypePipe,
    FileAndSuggestionToTypePipe,
    ImportanceLevelPipe,
    IconPipe,
    IconTypePipe,
    TrainerPipe,
    CoursePipe,
    MomentPipe,
    ReparatorPipe,
    LanguagesPipe,
    InspectionTypePipe,
    ActionsPipe,
    StatePriorityPipe,
    StatesPipe,
    PersonNamePipe,
    DiscussionCommentTypePipe,
    CountryPipe,
    PartsFilterPipe,
    AppCurrencyPipe,
    PrioritiesPipe,
    ResponsiblesPipe,
    NumberThousandPipe,
    PluginComponent,
    PluginDirective,
    DocumentTypePipe,
    ReceivedStatusPipe,
    CheckedStatusPipe,
    WeightUnitsPipe,
    IncotermsStatusPipe,
    MeasuringUnitsPipe,
    SurfaceTypePipe,
    LevelTypePipe,
    SupplierPipe,
    TimeUnitsPipe,
    StatusTypePipe,
    InstallationPreparationPipe,
    InstallationDistancePipe,
    CustomerCommentFromPipe,
    CommentToPipe,
    DynamicDirective,
    SubTypePipe,
    JobLabelPipe,
    YesNoStatusPipe,
    SignatureTypePipe,
    ObservationPrioritiesPipe,
    ObservationResponsiblesPipe
  ]
})
export class PluginModule {}
